<div class="sim-history-popover__backdrop" (click)="onClose()"></div>
<div
  #panel
  class="sim-history-popover__panel"
  role="dialog"
  tabindex="-1"
  [attr.aria-label]="title()"
  (keydown.escape)="onClose()"
>
  @if (groups().length) {
    <div class="sim-history-popover__header">
      <span class="sim-history-popover__title" simEllipsisTooltip>{{ title() }}</span>
      <button type="button" class="sim-history-popover__new" (click)="onNewItem()">
        <sim-icon icon="add" [sizeInPx]="16" />
        {{ newItemLabel() }}
      </button>
    </div>
    <div class="sim-history-popover__list">
      @for (group of groups(); track group.label) {
        <span class="sim-history-popover__group-label">{{ group.label }}</span>
        @for (item of group.items; track item.id) {
          <button
            type="button"
            class="sim-history-popover__item"
            [class.sim-history-popover__item--current]="item.id === currentId()"
            [attr.aria-current]="item.id === currentId() ? 'true' : null"
            (click)="onSelect(item.id)"
          >
            <span class="sim-history-popover__item-texts">
              <span class="sim-history-popover__item-title" simEllipsisTooltip>{{ item.title }}</span>
              @if (item.meta) {
                <span class="sim-history-popover__item-meta">{{ item.meta }}</span>
              }
            </span>
            @if (item.busy) {
              <span class="sim-history-popover__busy" role="status" [attr.aria-label]="busyLabel()">
                <sim-spinner [diameter]="14" [strokeWidth]="2" />
              </span>
            }
            @if (item.id === currentId() && currentLabel()) {
              <span class="sim-history-popover__current">{{ currentLabel() }}</span>
            }
          </button>
        }
      }
    </div>
  } @else {
    <div class="sim-history-popover__empty">
      <span class="sim-history-popover__empty-icon">
        <sim-icon icon="history_log" [sizeInPx]="20" />
      </span>
      <span class="sim-history-popover__empty-title">{{ emptyTitle() }}</span>
      <span class="sim-history-popover__empty-text">{{ emptyText() }}</span>
      <button type="button" class="sim-history-popover__empty-action" (click)="onNewItem()">
        {{ emptyActionLabel() }}
      </button>
    </div>
  }
</div>
